
function formatDate (date: Date, isStartDate: boolean = true) {
  const appendTime = isStartDate ? 'T00:00:00Z' : 'T23:59:59Z'
  const formattedDate = formatDateForUrl(date)
  return `${formattedDate}${appendTime}`
}

function formatDateForUrl (date: Date) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${year}-${(month <= 9 ? '0' + month : month)}-${(day <= 9 ? '0' + day : day)}`
}

function displayFormattedDateInFilter (date: Date) {
  const formattedShortMonth = new Intl.DateTimeFormat('en', { month: 'short' }).format(date)
  return `${formattedShortMonth} ${date.getDate()}, ${date.getFullYear()}`
}

function isSameDay (startDate: string, endDate: string) {
  return startDate === endDate
}

function getMonthStartDate () {
  let monthStartDate = new Date()
  monthStartDate.setDate(monthStartDate.getDate() - 30)
  monthStartDate.setHours(0, 0, 0, 0)
  return monthStartDate
}

function getYesterday () {
  let yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  yesterday.setHours(23, 59, 59, 0)
  return yesterday
}

export default { formatDate, formatDateForUrl, displayFormattedDateInFilter, isSameDay, getMonthStartDate, getYesterday }
